var _autocomplete;
var _sessionToken;
var _placesService;

class MaverickAutoComplete {
  constructor() {
    _autocomplete = new google.maps.places.AutocompleteService();
    _sessionToken = new google.maps.places.AutocompleteSessionToken();
    _placesService = new google.maps.places.PlacesService(document.createElement("div"));
  }

  getPredictions(keyword, callback, options) {
    if (!_sessionToken) {
      this.refreshToken();
    }
    // only trigger google service when char is more than equal to 3
    if (keyword.length >= 3) {
      const request = {
        input: keyword,
        sessionToken: _sessionToken,
      };
      if (options && options.country) {
        request.componentRestrictions = {
          'country': options.country
        }
      }
      _autocomplete.getPlacePredictions(request, (predictions, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          callback(predictions);
        }
      });
    }
  }

  getPlace(prediction, callback) {
    const request = {
      placeId: prediction.place_id,
      fields: ['name', 'formatted_address', 'geometry', 'address_component'],
      sessionToken: _sessionToken
    };
    _placesService.getDetails(request, (place, status) => {
      // renew session token everytime place details has been requested
      this.refreshToken();

      if (status === google.maps.places.PlacesServiceStatus.OK) {
        let country = '';
        for (let i = place.address_components.length - 1; i >= 0; i--) {
          if (place.address_components[i].types.find(x => x.toLowerCase() === 'country') !== undefined) {
            country = place.address_components[i].short_name;
            break;
          }
        }
        callback({
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng(),
          name: place.name,
          address: `${place.name}, ${place.formatted_address}`,
          country: country
        });
      }
    });
  }

  refreshToken() {
    _sessionToken = new google.maps.places.AutocompleteSessionToken();
  }
}

export default MaverickAutoComplete;



// WEBPACK FOOTER //
// ./src/plugins/google/autocomplete.js